<template>
  <div>
    <header class="header-area style-1" :class="scrollTop > 0 && 'sticky'">
      <div class="header-logo" @click="toHome()">
        <a href="index.html">
          <img src="@/assets/img/logo_white.png" alt="海南华德科技有限公司" class="img-fluid" />
        </a>
      </div>

      <div class="main-nav" :class="{ 'show-menu': isMenuVisible }">
        <!-- 移动端菜单头部 -->
        <MobileMenuHeader v-if="isMobileView" @close="handleMenu" />

        <!-- 导航菜单 -->
        <NavigationMenu
          :navList="processedNavList"
          :isMenuVisible="isMenuVisible"
          :isMobile="isMobileView"
          @nav-click="handleNavClick"
        />
      </div>

      <!-- 右侧联系方式 -->
      <ContactInfo :isMenuVisible="isMenuVisible" @menu-toggle="handleMenu" />
    </header>
  </div>
</template>

<script>
import { NAV_LIST } from "./components/navConfig";
import MobileMenuHeader from "./components/MobileMenuHeader.vue";
import NavigationMenu from "./components/NavigationMenu.vue";
import ContactInfo from "./components/ContactInfo.vue";

export default {
  name: "HeaderNew",
  components: {
    MobileMenuHeader,
    NavigationMenu,
    ContactInfo,
  },
  data() {
    return {
      isMenuVisible: false,
      scrollTop: 0,
      navList: NAV_LIST,
      isMobileView: window.innerWidth < 992,
    };
  },
  computed: {
    processedNavList() {
      // 必须返回响应式数据本身（navList 已是 NAV_LIST 的深拷贝，可安全改动）。
      // 若像以前那样返回 navList.map(item => ({...item})) 的浅拷贝普通对象，
      // NavigationMenu/SubMenu 里用 $set 切换的 open（展开态）不具响应性，视图不会更新。
      return this.navList;
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.setActiveNavFromRoute();
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
  },
  watch: {
    $route() {
      this.setActiveNavFromRoute();
    },
  },
  methods: {
    handleResize() {
      this.isMobileView = window.innerWidth < 992;
      if (!this.isMobileView) {
        this.isMenuVisible = false;
      }
    },
    handleScroll() {
      this.scrollTop = window.scrollY;
    },
    setActiveNavFromRoute() {
      // Deep clone the original NAV_LIST to reset
      this.navList = JSON.parse(JSON.stringify(NAV_LIST));

      const currentPath = this.$route.path;
      let found = false;

      // First check for exact matches (for subItems)
      outerLoop: for (let i = 0; i < this.navList.length; i++) {
        const topItem = this.navList[i];

        if (topItem.children) {
          for (let j = 0; j < topItem.children.length; j++) {
            const child = topItem.children[j];

            if (child.subItems) {
              for (let k = 0; k < child.subItems.length; k++) {
                if (currentPath === child.subItems[k].path) {
                  topItem.active = true;
                  child.active = true;
                  child.subItems[k].active = true;
                  // 移动端打开抽屉时自动展开到当前所在项
                  topItem.open = true;
                  child.open = true;
                  found = true;
                  break outerLoop;
                }
              }
            }
          }
        }
      }

      // If no exact subItem match found, check for path startsWith
      if (!found) {
        for (let i = 0; i < this.navList.length; i++) {
          const topItem = this.navList[i];

          if (currentPath.startsWith(topItem.path)) {
            topItem.active = true;
            topItem.open = true; // 移动端自动展开当前所在分支
            found = true;

            if (topItem.children) {
              for (let j = 0; j < topItem.children.length; j++) {
                const child = topItem.children[j];

                if (currentPath.startsWith(child.path)) {
                  child.active = true;
                  child.open = true;
                  break;
                }
              }
            }
            break;
          }
        }
      }

      // If still not found and we're at home page, activate first item
      if (!found && currentPath === "/") {
        this.navList[0].active = true;
      }
    },
    handleNavClick() {
      // 移动端：能冒到这里的都是"跳转"动作（带子项的展开型点击已在 NavigationMenu/
      // SubMenu 的捕获阶段被拦截，不会 emit），跳转后关闭抽屉
      if (this.isMobileView) {
        this.isMenuVisible = false;
      }
    },
    handleMenu() {
      this.isMenuVisible = !this.isMenuVisible;
    },
    toHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style>
@import url("../assets/css/animate.css");
@import url("../assets/css/all.css");
/* @import url("../assets/css/bootstrap.min.new.css"); */
@import url("../assets/css/bootstrap.min.css");
@import url("../assets/css/boxicons.min.css");
@import url("../assets/css/bootstrap-icons.css");
@import url("../assets/css/swiper-bundle.css");
@import url("../assets/css/nice-select.css");
@import url("../assets/css/magnific-popup.css");
/* @import url("../assets/css/odometer.css"); */
@import url("../assets/css/style.css");
/* @import url("../assets/css/jquery-ui.css"); */
</style>



// WEBPACK FOOTER //
// src/components/HeaderNew.vue